<svelte:options accessors/>
<script>
    import NauiExplorer from "../../../naui/pages/NauiExplorer.svelte";

    export let data;
    export let columns;
    export let filters;
    export let pages;
</script>
<div class="py-15">
    <NauiExplorer {data}
                  {pages}
                  {columns}
                  {filters}
                  hideSearch={true}
                  paginate={true}
                  on:filter
                  on:next />
</div>